import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon_bar",
  "use": "icon-icon_bar-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon_bar\">\n<path d=\"M0 7.2H5.14286V24H0V7.2ZM9.6 0H14.4V24H9.6V0ZM19.2 13.7143H24V24H19.2V13.7143Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol